import { GsbApiService } from "../../api/gsb-api.service.js";
import { logger } from "../../utils/logger.js";
import { safeErrorDetails } from "../../utils/error-details.js";
import { AuthProtocolGuards } from "./auth-protocol.js";
import { BrowserRegistry } from "../../registry.js";
export class AuthWireService {
    apiService;
    options;
    guards = new AuthProtocolGuards();
    validateOutcome;
    validateVerifyOutcome;
    composeAuthValidation(validate, verify) {
        this.validateOutcome = validate;
        this.validateVerifyOutcome = verify;
    }
    checkOutcome(value) {
        const guarded = this.guards.validOutcome(value);
        const core = this.validateOutcome?.(value) ?? true;
        if (!guarded ||
            !core ||
            BrowserRegistry.lookup("validation")?.auth?.validOutcome(value) === false) {
            throw new Error("Invalid authentication response.");
        }
    }
    constructor(apiService = GsbApiService.getInstance(), options = {}) {
        this.apiService = apiService;
        this.options = options;
    }
    callApi(req, endPoint, token, tenantCode) {
        return this.apiService.callApi({
            useBulk: this.options.useBulk ?? true,
            ...req,
            ...(this.options.apiBaseUrl
                ? { apiBaseUrl: this.options.apiBaseUrl }
                : {}),
            ...(this.options.useAuth === false ? { noAuth: true } : {}),
        }, endPoint, token, tenantCode);
    }
    async getToken(request) {
        try {
            // Use apiService for consistency
            const response = await this.apiService.callApi({
                method: "POST",
                protocol: "https",
                hostName: "api",
                content: request,
                jsonResponse: true,
                noAuth: true,
                useBulk: false,
            }, "/api/auth/getToken");
            this.checkOutcome(response);
            return response;
        }
        catch (error) {
            logger.debug("Authentication request failed", safeErrorDetails(error));
            throw error;
        }
    }
    async verifyToken(request, token) {
        const response = await this.apiService.callApi({
            method: "POST",
            protocol: "https",
            hostName: "api",
            content: request,
            jsonResponse: true,
            noAuth: token === undefined,
            useBulk: false,
        }, "/api/auth/verifyToken", token, request.variation.tenantCode);
        const validCoreOutcome = this.validateVerifyOutcome?.(response) ?? true;
        if (!this.guards.validVerifyOutcome(response) ||
            !validCoreOutcome ||
            BrowserRegistry.lookup("validation")?.auth?.validVerifyOutcome(response) === false)
            throw new Error("Invalid authentication response.");
        return response;
    }
    async refreshToken(request, token, tenantCode) {
        try {
            // Use apiService for consistency
            const response = await this.apiService.callApi({
                method: "POST",
                protocol: "https",
                hostName: "api",
                content: request,
                jsonResponse: true,
                useBulk: false,
            }, "/api/auth/refreshToken", token, tenantCode);
            this.checkOutcome(response);
            return response;
        }
        catch (error) {
            logger.debug("Authentication request failed", safeErrorDetails(error));
            throw error;
        }
    }
    async runWfFunction(req, token, tenantCode) {
        return this.callApi({
            method: "POST",
            protocol: "https",
            hostName: "api",
            content: req,
            useBulk: false,
        }, "/api/workflow/runFunction", token, tenantCode);
    }
    async changePassword(req, token, tenantCode) {
        return this.apiService.callApi({
            method: "POST",
            protocol: "https",
            hostName: "api",
            content: req,
            useBulk: false,
        }, "/api/auth/changePassword", token, tenantCode);
    }
}
//# sourceMappingURL=auth-wire.service.js.map